import React from 'react';
import CollapsedFlightDetailItem from './CollapsedFlightDetailItem';

interface FlightDetailItemContainerProps {
  aircraftId: string;
}

export const FlightDetailItemContainer: React.FC<FlightDetailItemContainerProps> = ({
  aircraftId
}) => {
  return (
    <div className="flight-detail-item-container">
      <CollapsedFlightDetailItem aircraftId={aircraftId} />
    </div>
  );
};
